module.exports = __webpack_public_path__ + "img/clockIcon.baa222ba.svg";